import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonCloudStudioModule, DashboardModule } from 'common-cloudstudio';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DashboardComponent } from 'src/app/customer-modules/apolus/dashboard/dashboard.component';
import { SharedModule } from 'src/app/customer-modules/apolus/shared/shared.module';

@NgModule({
  declarations: [
    DashboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CommonCloudStudioModule,
    DashboardModule,
    SharedModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    DashboardComponent,
  ],
})
export class DashboardCustomerModule {}
